export default __webpack_public_path__ + "15cbc4e25c6f4c66c5a8373d88143e86.svg";